import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { CardImg } from 'reactstrap';
//import { Link } from 'react-router-dom'; use HashLink instead
import { HashLink as Link } from 'react-router-hash-link';
import smoothscroll from 'smoothscroll-polyfill';
import { PhoneBanner } from '../PhoneBanner';
import './styles.css';

// https://react-bootstrap.github.io/components/navbar/
// Spacing: https://getbootstrap.com/docs/4.1/utilities/spacing/
// Link color https://stackoverflow.com/questions/49195684/set-color-to-reactsrap-navlink

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    render() {
        // kick off the polyfill!
        // works for the Link (not <a> tag)
        smoothscroll.polyfill();
        return (
            <header>
                <Container>
                    <PhoneBanner />
                    <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-0 my-navbar" style={{ backgroundColor: '#242424' }}>
                        { /*<Container>*/}
                        <NavbarBrand tag={Link} to="/"><CardImg src='images/pacific-logo-241x61.png' className='logo-image' alt='Pacific Motosports logo' /></NavbarBrand>
                        <NavbarToggler onClick={this.toggleNavbar} className="mr-2" style={{ backgroundColor: 'grey', color: 'white' }} />
                        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
                            <ul className="navbar-nav flex-grow">
                                {/*
                                <NavItem>
                                    <NavLink tag={Link} to="/">Home</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} to="/default">Default</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} to="/">Parts</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} to="/" style={{ color: 'white', fontSize: '1.2em' }}>Social</NavLink>
                                </NavItem>
                               
                                <NavItem>
                                    <NavLink tag={Link} to="/#apparel" style={{ color: 'white', fontSize: '1.2em' }}>Gear</NavLink>
                                </NavItem>
                                */}
                                <NavItem>
                                    <NavLink tag={Link} to="/#apparel" style={{ color: 'white', fontSize: '1.2em' }}>Gear & Apparel</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} to="/#contact-us" style={{ color: 'white', fontSize: '1.2em' }}>Contact Us</NavLink>
                                </NavItem>
                            </ul>
                        </Collapse>
                        { /*</Container>*/}
                    </Navbar>
                    </Container>
            </header>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/NavMenu/index.js